module.exports = __webpack_public_path__ + "img/pcba_10@2x.5ba8fed9.png";